// @flow

import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';

export const StyledToastContainer = styled(ToastContainer)`
  &&&.Toastify__toast-container {
    width: fit-content;
    max-width: 90vw;
  }
  .Toastify__toast--error {
    border: 2px solid #eb5757;
    background: #f2e6e6 !important;
  }
  .Toastify__toast {
    max-height: 65vh;
  }
  .Toastify__toast-body {
    align-items: flex-start;
    max-height: 60vh;
    overflow-y: auto;
    white-space: pre-wrap;
    word-break: break-word;
  }
`;
